import React, { Fragment } from "react";
import { useMediaQuery } from "react-responsive";
import { Box, Divider, Typography } from "@mui/material";
import { styled } from "@mui/system";
import useSystemHook from "./../../hooks/SystemHook";

const PageHeader = ({ title, subtitle, sx }) => {
  const { isMobile, isTablet, isDesktop } = useSystemHook();

  const HeaderContainer = styled(Box)(({ theme }) => ({
    backgroundColor: "#f5f5f5",
    padding: theme.spacing(2, 4),
    ...sx,
  }));

  return (
    <Fragment>
      <HeaderContainer>
        <Typography variant="h5" gutterBottom>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body1" color="textSecondary">
            {subtitle}
          </Typography>
        )}
      </HeaderContainer>
    </Fragment>
  );
};

export default PageHeader;
